module.exports = __webpack_public_path__ + "img/eematico-toys-banner.b23c6f96.jpg";